import React from "react";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import axios from "axios";
import "./Productslist.css";
import { Link } from "react-router-dom";

function Productslist() {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const result = await axios({
        method: "GET",
        url: "https://asos2.p.rapidapi.com/products/v2/list",
        params: {
          store: "US",
          offset: "0",
          categoryId: `${id}`,
          limit: "48",
          country: "US",
          sort: "freshness",
          currency: "USD",
          sizeSchema: "US",
          lang: "en-US",
        },
        headers: {
          "x-rapidapi-key":
            "c2148b3dfamshd0306d645183132p1c3dbdjsnb84cbd6468dd",
          "x-rapidapi-host": "asos2.p.rapidapi.com",
        },
      });

      setProducts(result.data);
      setProductsList(result.data.products);
      console.log(products);
      console.log(productsList);
      setLoading(false);
    })();
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading text-center">
          <div className="spinner-grow text-dark" role="status"></div>
          <div className="spinner-grow text-warning" role="status"></div>
          <div className="spinner-grow text-dark" role="status"></div>
        </div>
      ) : (
        <div className="container products-list text-center">
          <div className="search text-end">
            <input
              className="search-box"
              type="text"
              placeholder="Search"
              onChange={handleChange}
            />
            <i className="fas fa-search"></i>
          </div>
          <h4 className="category-name">{products.categoryName}</h4>
          <div className="row">
            {productsList
              .filter((pro) => {
                if (pro.name.toLowerCase().includes(search.toLowerCase())) {
                  return pro;
                } else {
                  return null;
                }
              })
              .map((pro) => (
                <div key={pro.id} className="col-lg-2 col-m-3 col-6 card ">
                  <img
                    className="card-img-top"
                    src={"http://" + pro.imageUrl}
                    alt={pro.name}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{pro.name}</h5>
                    <div className="product-price">
                      <h6>
                        <span>{pro.price.current.text}</span>
                      </h6>
                      <h6>
                        <del>{pro.price.previous.text}</del>
                      </h6>
                    </div>
                    <Link
                      to={`/details/${pro.id}`}
                      className="btn btn-primary bg-dark"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
}

export default Productslist;
